import { gql } from "@apollo/client";

export const STREAM_SETTINGS_QUERY = gql`
    query StreamSettingsQuery {
        streamSettings {
            id
            goldenWoh
            doubleSentry
            acceptingApplications
            doubleShieldMateRewards
            streamTeamRewardName
            streamTeamRewardDescription
            streamTeamRewardCost
            streamTeamRewardBackgroundColor
            streamTeamRewardUserInputRequired
            streamTeamRewardSkipQueue
            streamTeamRewardGlobalCooldownEnabled
            streamTeamRewardMaxPerStreamEnabled
            streamTeamRewardMaxPerUserPerStreamEnabled
            streamTeamRewardGlobalCooldownSeconds
            streamTeamRewardLimitPerStream
            streamTeamRewardLimitPerUserPerStream
            streamTeamRewardRpAmount
            academyRewardName
            academyRewardDescription
            academyRewardCost
            academyRewardBackgroundColor
            academyRewardUserInputRequired
            academyRewardSkipQueue
            academyRewardGlobalCooldownEnabled
            academyRewardMaxPerStreamEnabled
            academyRewardMaxPerUserPerStreamEnabled
            academyRewardGlobalCooldownSeconds
            academyRewardLimitPerStream
            academyRewardLimitPerUserPerStream
            academyRewardRpAmount
            raidRpPerViewer
            raidRpMinimumViewers
            academyRaidRpEnabled
            subscriberRpAmountTier1000
            subscriberRpAmountTier2000
            subscriberRpAmountTier3000
            academySubscriberRpEnabled
            freeRunestoneRpThreshold
        }
    }
`;

export const CHECK_TWITCH_TOKEN_STATUS_QUERY = gql`
    query CheckTwitchTokenStatusQuery {
        checkTwitchTokenStatus
    }
`;
